import { FaArrowLeftLong } from 'react-icons/fa6'

const IconBack = () => {
    return <FaArrowLeftLong />
}

export default IconBack
